import TransactionStorage from "../utilities/TransactionStorage.js";
import Request from '../utilities/Request.jsx';
import transactionSerializer, { transactionPostData } from "./services/transactionSerializer.jsx";

export default class TransactionSubmitter {


	/**
	 * returns promise array with status: fulfilled/rejected  value:
	 */
	static async submit(everyTimeASubmissionIsSuccessfulCallback, everyTimeASubmissionFailsCallback) {
		const promises = [];
		return TransactionStorage.iterate((transaction) => {
				promises.push(
					Request.apiv1Post('budget/transactions', transactionPostData(transaction))
						.then((response) => {
							if(everyTimeASubmissionIsSuccessfulCallback) {
								everyTimeASubmissionIsSuccessfulCallback(response.transaction);
							}
							return response;
						})
						.catch((error) => {
							console.error(error);
							transaction.submitError = error.toString();
							console.log('the trans', transaction);
							if(everyTimeASubmissionFailsCallback) {
								everyTimeASubmissionFailsCallback(error);
							}
							return TransactionStorage.setItem(transaction.submit_id, transactionSerializer(transaction))
								.then(()=>{
									return error;
								})
						})
				);
			})
			.then(() => {
				// console.log('Submit iteration completed');
				return Promise.allSettled(promises);
			})
			.catch((error) => {
				// console.error('Iteration error!');
				throw error;
			});
	}
}